import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
    topLeftSlot: {
      overflow: 'hidden',
    },
    titleWrapper: {
      overflow: 'hidden',
    },
  })
);

export default useStyles;
